import { Button, Stack, Autocomplete, TextField } from "@mui/material";
import React, { useState } from "react";
import Modal, { CommonModalProps } from "..";
import { DbOrderBasketItemInfos } from "../../../Core/Api/Types/db-order-basket-item-infos";
import { useDispatch, useSelector } from "react-redux";
import { GetBasket, ItemField, UpdateItemRootOnBasket } from "../../../Redux/Reducers/redux-slice-basket";
import { IsEmail } from "../../../Utils/helpers";
import { useTranslation } from "react-i18next";

export type ModalCheckoutContactsElementProps = {
  onClose?: () => void;
  item: DbOrderBasketItemInfos;
};

export type ModalCheckoutContactsProps = CommonModalProps<ModalCheckoutContactsElementProps>;

const ModalCheckoutContacts = React.forwardRef<any, ModalCheckoutContactsProps>((props, ref) => {
  const { item, closeModal, onClose } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [emails, setEmails] = useState<string[]>(item.billingEmails ? item.billingEmails! : []);
  const basket = useSelector(GetBasket);

  const handleCancelClick: React.MouseEventHandler = () => {
    closeModal();
  };

  const handleConfirmClick = (itemId: number, close: boolean = true) => {
    // Update redux
    dispatch(
      UpdateItemRootOnBasket({
        itemId: itemId,
        field: ItemField.BillingEmails,
        value: emails,
      })
    );

    onClose && onClose();
    closeModal();
  };

  const handleApplyToAll: React.MouseEventHandler = () => {
    basket.items?.forEach((item) => {
      handleConfirmClick(item.id, false);
    });
  };

  return (
    <Modal
      title={t("common:contacts")}
      reference={ref}
      closeModal={closeModal}
      width={600}
      footer={
        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Button onClick={handleApplyToAll}>{t("button:applyToAllItems")}</Button>
          <Button variant="contained" onClick={() => handleConfirmClick(item.id)}>
            {t("common:done")}
          </Button>
        </Stack>
      }
    >
      <Autocomplete
        sx={{ mt: -2 }}
        id="form-emails"
        freeSolo={true}
        multiple={true}
        options={[]}
        onChange={(e, v) => {
          if (v.length > 0 && !IsEmail(v[v.length - 1])) return;
          setEmails(v === null ? [] : v);
        }}
        getOptionLabel={(value: any) => value}
        isOptionEqualToValue={(option, value) => option === value}
        value={emails}
        renderInput={(params) => <TextField {...params} placeholder={t("field:placeholder.email")} />}
      />
    </Modal>
  );
});

export default ModalCheckoutContacts;
